/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["h1{font-size:1.5rem!important}h2{font-size:1.3rem!important}p>a{background:#fff!important;font-family:Lato,Arial,sans-serif!important;box-shadow:inset 0 -2px 0 #b6c9da!important;color:#5a7186!important;border:1px solid transparent!important;border-radius:6px!important;border-color:#d8e2eb #d8e2eb #b6c9da!important;padding:3px 18px!important;font-size:1.1rem!important;line-height:28px!important;font-weight:700!important}p>a:hover{background-color:#e2e9f0!important;border-color:#c7d5e2!important}"];
export { styles as styles };
